import styled from '@emotion/styled';
import React from 'react';

import {formattedHoursWithUnit} from '_/utilities/temporal';

import {EventAssignmentSummary} from '../types';
import {getTotalEventDurationInHours} from '../utilities/date';

export const ActivityWarnings = ({
  eventsSummary,
}: {
  eventsSummary: EventAssignmentSummary;
}): React.ReactElement => {
  const unassignedHours = getTotalEventDurationInHours(
    eventsSummary.unassigned
  );

  const hasUnassigned = unassignedHours > 0;
  const hasOverlappingHours = eventsSummary.hasOverlap;

  const hasErrors = hasUnassigned || hasOverlappingHours;

  return (
    <>
      {hasErrors && (
        <Warning>
          {hasUnassigned && (
            <div>
              {formattedHoursWithUnit(unassignedHours)} sind noch keinem Dossier
              zugeordnet!
            </div>
          )}
          {hasOverlappingHours && (
            <div>Es gibt überlappende Zeiterfassungen!</div>
          )}
        </Warning>
      )}
    </>
  );
};

const Warning = styled.div`
  // box
  background-color: var(--color-alerts-info);
  border-top: var(--color-core-dark-grey) solid 1px;
  padding: var(--gutter-little);

  align-self: flex-end;
  width: 100%;

  & div {
    text-align: center;
  }
`;
